const PANEL_DEFAULT_WIDTH = 400;
const PANEL_MAX_WIDTH = 1000;
const MINIMUM_WIDTH = 1800;
const PANEL_TO_WINDOW_WITH_RATIO = 0.3;

export const getDefaultPanelWidth = () => {
	const windowWidth = window.innerWidth;

	let width = PANEL_DEFAULT_WIDTH;
	if (windowWidth >= MINIMUM_WIDTH) {
		const proposedPanelWidth = Math.round(windowWidth * PANEL_TO_WINDOW_WITH_RATIO);

		width = proposedPanelWidth < PANEL_MAX_WIDTH ? proposedPanelWidth : PANEL_MAX_WIDTH;
	}
	return width;
};
